import React, { useState } from "react";
import "./martsfilters.css";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FiltersSection = ({ activeTab = "filters", onTabChange = () => {} }) => {
  const [open, setOpen] = useState(false);
  const [expandedSections, setExpandedSections] = useState({});
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);

  const handleTabClick = (tab) => {
    setIsFilterPanelOpen(!isFilterPanelOpen);
    setOpen(!open);

    // if (tab === 'filters') {
    //   if (open === true) {
    //     setIsFilterPanelOpen(!isFilterPanelOpen);
    //     setOpen(!open);
    //   } else {
    //     setOpen(!open);
    //     setIsFilterPanelOpen(true);
    //   }
    // }
    // else {
    //   setActive(tab);
    //   setIsFilterPanelOpen(false);
    // }
    // onTabChange(tab);
  };

  const toggleSection = (sectionName) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionName]: !prev[sectionName],
    }));
  };

  const filterSections = [
    { id: "basic", title: "Basic Filters" },
    { id: "duration", title: "Duration Filters" },
    { id: "flag", title: "Flag Filters" },
    { id: "advance", title: "Advance Filters" },
    { id: "metric", title: "Metric Filters" },
    { id: "rank", title: "Rank Filters" },
    { id: "grouping", title: "Grouping Filters" },
  ];

  return (
    <div className="filters-container">
      {/* Your existing sidebar navigation */}
      <div className="sidebar-navigation">
        <div
          className="sidebar-tab sidebar-tab-disabled"
        >
          <span className="sidebar-tab-text">Filters</span>
        </div>

        <div
          className="sidebar-tab sidebar-tab-disabled"
        >
          <span className="sidebar-tab-text">Marts</span>
        </div>

        <div
          className="sidebar-tab sidebar-tab-disabled"
        >
          <span className="sidebar-tab-text">Sections</span>
        </div>
      </div>

      {/* Filter Panel that appears when filters is active */}
      {open === true && isFilterPanelOpen && (
        <div className="filter-panel">
          <div className="filter-accordion">
            {filterSections.map((section) => (
              <div key={section.id} className="filter-section">
                <div
                  className="filter-section-header"
                  onClick={() => toggleSection(section.id)}
                >
                  <h3 className="filter-section-title">{section.title}</h3>
                  <ExpandMoreIcon
                    className={`expand-icon ${
                      expandedSections[section.id] ? "expanded" : ""
                    }`}
                  />
                </div>

                {expandedSections[section.id] && (
                  <div className="filter-section-content">
                    <div className="filter-options">
                      <label className="filter-checkbox">
                        <input type="checkbox" />
                        <span>Filter Option 1</span>
                      </label>
                      <label className="filter-checkbox">
                        <input type="checkbox" />
                        <span>Filter Option 2</span>
                      </label>
                      <label className="filter-checkbox">
                        <input type="checkbox" />
                        <span>Filter Option 3</span>
                      </label>
                    </div>
                  </div>
                )}
              </div>
            ))}

            {/* Action buttons */}
            <div className="filter-actions">
              <button className="cancel-btn">Cancel</button>
              <button className="reset-btn">Reset</button>
              <button className="save-apply-btn">
                <span className="save-icon"></span> Save & Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FiltersSection;
